export const initialState = {
    instances: [],
    userData: {
        instance: null,
        userId: null,
        firstName: null,
        lastName: null,
        isOptedIn: null
    },
};

const userReducer = (state, action) => {
    const { type, payload } = action;
    let newState = { ...state };

    switch (type) {
        case "INITIALIZE_NAV_BAR":
            const { instances, userData } = payload;
            return {
                ...newState,
                instances,
                userData
            };
        case "UPDATE_USER_DATA": {
            const {  instance, isOptedIn } = payload;
            return {
                ...newState,
                userData: {
                    ...newState.userData,
                    instance, isOptedIn
                }
            };
        }
        default:
            return newState;
    }
};

export default userReducer;